exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_box__WuJnm,.style_information__hNEcB{padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_information__hNEcB{background:rgba(8,120,209,.1)}.style_information__hNEcB .style_title__3E4i5{color:#0878d1}.style_success__2MJei{background:rgba(72,179,80,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_success__2MJei .style_title__3E4i5{color:#48b350}.style_warning__mS5OQ{background:rgba(251,140,0,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_warning__mS5OQ .style_title__3E4i5{color:#fb8c00}.style_danger__3pDp5{background:rgba(219,68,55,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_danger__3pDp5 .style_title__3E4i5{color:#db4437}.style_none__3NoL2{padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_title__3E4i5{margin-bottom:.625rem}", ""]);

// exports
exports.locals = {
	"box": "style_box__WuJnm",
	"information": "style_information__hNEcB",
	"title": "style_title__3E4i5",
	"success": "style_success__2MJei",
	"warning": "style_warning__mS5OQ",
	"danger": "style_danger__3pDp5",
	"none": "style_none__3NoL2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Callout/style.less
// module id = 1652
// module chunks = 8